jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/accordion.js');
  require('./components/team-popup.js');
  require('./components/adventure-popup.js');

  loadMoreTeam.init();
});


AOS.init();


// Category Filter
jQuery(document).ready(function($) {
  $('#category-select').change(function() {
    var selectedTag = $(this).val();
    var currentPage = parseInt($('#current-page').data('current-page'));
    var featuredID = parseInt($('#featured-id').data('featured-id'));

    $.ajax({
      type: 'POST',
      url: posts.ajaxurl,
      data: {
        action: 'filter_posts',
        category: selectedTag,
        page: currentPage,
        ID: featuredID,
      },
      success: function(response) {
        $('#load-posts-container').html(response);

        if(selectedTag !== 'all') {
          $('.post-navigation').hide();

        } else {
          $('.post-navigation').show();
        }
      },
    });
  });
});


// Locations Filter
jQuery(document).ready(function($) {
  $('.locations-category li').on('click', function() {

    $('.locations-category li').removeClass('active');
    $(this).addClass('active');

    var selectedTag = $(this).data('tag');

    $.ajax({
      type: 'POST',
      url: posts.ajaxurl,
      data: {
        action: 'filter_locations',
        tag: selectedTag,
      },

      success: function(response) {
        $('#load-locations-container').html(response);
      },
    });
  });
});


// Load More Team
var loadMoreTeam = {
	init: function() {
    jQuery('#load-more-team').click(function(){
      loadMoreTeam.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-team-container');
		var postCount = jQuery('#load-team-container .team-member').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_team',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,

			beforeSend: function () {
				jQuery('#load-more-team').addClass('loading');
			},

			complete: function () {
				jQuery('#load-more-team').removeClass('loading');
			},

			success: function(data) {
				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-team-container .team-member').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more-team').replaceWith('<a class="main-button plus-button no-posts" href="#load-more-team-anchor">Back to top</a>');
				}

				return;
			}
		});
	}
}


// Call To Action OverLay
function addContentOverlay(paddingSize) {
  var ctaElements = document.querySelectorAll('.call-to-action');

  ctaElements.forEach(function(ctaElement) {
    var ctaHeight = ctaElement.clientHeight;
    var halfHeight = ctaHeight / 2;

    const beforeSibling = ctaElement.previousElementSibling;
    const afterSibling = ctaElement.nextElementSibling;

    if(beforeSibling) {
      if(beforeSibling.classList.contains('archive-locations')) {
        beforeSibling.style.paddingBottom = (halfHeight + paddingSize) + 'px';
        beforeSibling.style.marginBottom = (halfHeight - halfHeight - halfHeight) + 'px';

      } else if(beforeSibling.classList.contains('page-links')) {
        prevSiblingContainer = beforeSibling.querySelector('.container');
        prevSiblingContainer.style.paddingBottom = (halfHeight + paddingSize) + 'px';
        prevSiblingContainer.style.marginBottom = (halfHeight - halfHeight - halfHeight) + 'px';
      }
    }

    if(afterSibling) {
      if(afterSibling.classList.contains('archive-locations')) {
        afterSibling.style.paddingTop = (halfHeight + paddingSize + 30) + 'px';
        afterSibling.style.marginTop = (halfHeight - halfHeight - halfHeight) + 'px';

      } else if(afterSibling.classList.contains('page-links')) {
        nextSiblingContainer = afterSibling.querySelector('.container');
        nextSiblingContainer.style.paddingTop = (halfHeight + paddingSize + 30) + 'px';
        nextSiblingContainer.style.marginTop = (halfHeight - halfHeight - halfHeight) + 'px';
      }
    }
  });
}

var pageSize = window.matchMedia("(max-width: 1024px)");

if(pageSize.matches) {
  addContentOverlay(60);

} else {
  addContentOverlay(80);
}

window.addEventListener('resize', function() {
  if(pageSize.matches) {
    addContentOverlay(60);

  } else {
    addContentOverlay(80);
  }
});


// Sibling Sections
function siblingSections(section, sectionClass) {
  const mapContainers = document.querySelectorAll(section);

  mapContainers.forEach(mapContainer => {
    const contactFormSibling = mapContainer.nextElementSibling;
    const hasContactFormSibling = contactFormSibling && contactFormSibling.classList.contains(sectionClass);

    if(hasContactFormSibling) {
      mapContainer.classList.add('active');

    } else if(!contactFormSibling) {
      mapContainer.classList.add('active-last');

    } else {
      const prevSibling = mapContainer.previousElementSibling;

      if(prevSibling && prevSibling.classList.contains(sectionClass)) {
        mapContainer.classList.add('active-before');
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', siblingSections('.map-container', 'contact-form'));
document.addEventListener('DOMContentLoaded', siblingSections('.team', 'main-color'));


// Add Child Button
const myButton = document.querySelector('.gpnf-add-entry');
const myElements = document.querySelectorAll('.gpnf-nested-entries');

if(myButton && myElements.length > 0) {
  function addClassToElements() {
    myElements.forEach(element => {
      element.classList.add('active-child');
    });
  }

  myButton.addEventListener('click', addClassToElements);
}